import { useState, useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { useCommon } from 'contexts/CommonContext';
import { unauthorizedAccess } from 'api/CommonApi';

export const PrivateRouteAsync = ({ component: Component, hasPermission, ...rest }) => {
  const { common: { loggedUser } } = useCommon();
  const [permissionState, setPermissionState] = useState({
    loading: false,
    authorized: null,
    checked: false,
  });
  const isMountedRef = useRef(true);
  const hasCheckedRef = useRef(false);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const checkPermission = useCallback(async () => {
    if (hasCheckedRef.current || !loggedUser || permissionState.loading) {
      return;
    }

    hasCheckedRef.current = true;
    setPermissionState({ loading: true, authorized: null, checked: false });

    try {
      const result = await hasPermission(loggedUser);

      if (isMountedRef.current) {
        setPermissionState({
          loading: false,
          authorized: result,
          checked: true,
        });

        if (!result) {
          unauthorizedAccess();
        }
      }
    } catch (error) {
      if (isMountedRef.current) {
        setPermissionState({
          loading: false,
          authorized: false,
          checked: true,
        });
        unauthorizedAccess();
      }
    }
  }, [loggedUser]);

  useEffect(() => {
    if (loggedUser && !permissionState.checked) {
      checkPermission();
    }
  }, [loggedUser, permissionState.checked, checkPermission]);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!permissionState.checked && loggedUser) {
          return <></>;
        }

        if (permissionState.loading) {
          return <></>;
        }

        if (permissionState.authorized) {
          return <Component {...props} />;
        }
        return null;
      }}
    />
  );
};

PrivateRouteAsync.propTypes = {
  hasPermission: PropTypes.func.isRequired,
  component: PropTypes.any.isRequired,
};
